import { useContext } from 'react';
import { UiContext } from '@/contexts/ui';

export const useUiStatus = () => useContext(UiContext);
